module.exports = __webpack_public_path__ + "assets/img/32_534.8260deeb.jpg";